/**
 * 商城模块接口列表
 */
import axios from '@/api/http.js'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

// get传参格式
// axios.get('demo/url', {
//     params: {
//         id: 18,
//         name: 'jay',
//     },
//    timeout: 1000,
//   ...//其他相关配置
// })

// post传参格式
// axios.post('demo/url', {
//     id: 18,
//     name: 'jay',
// },{
//    timeout: 1000,
//     ...//其他相关配置
// })

const mall = {
    // 系统更新设置
    getUpdateSettings: (params) => {
        return axios.get(`/api/api/index/getUpdateSettings`, { params });
    },
    // 获取省市区列表
    getprovinceAndCityList: (params) => {
        return axios.get(`/api/api/my/getAddressJSONArray`, { params });
    },
    //登录////////////////////////////////////////////////////////////////////////////////
    // 模拟登录
    testLogin(params) {
        return axios.get(`/api/api/login/testLogin`, { params });
    },
    // 发送验证码
    captchaSms(params) {
        return axios.get(`/api/api/login/captchaSms`, { params });
    },
    // 验证码登录
    smsLogin(params) {
        return axios.post(`/api/api/login/smsLogin`, params);
    },
    // 获取公司列表
    getCompanyList: (params) => {
        return axios.get('/api/api/login/getCompanyNames', { params })
    },
    // 注册
    register: (params) => {
        return axios.post('/api/api/login/register', params)
    },

    //首页接口////////////////////////////////////////////////////////////////////////////////
    // 获取置顶品牌
    getTopBrand: (params) => {
        return axios.get('/api/api/index/getTopBrand', { params })
    },
    // 获取轮播图
    getSwiper: (params) => {
        return axios.get('/api/api/index/getRotationChart', { params })
    },
    // 获取公告
    getNotice: (params) => {
        return axios.get('/api/api/article/getArticle', { params })
    },
    // 获取详情
    getNoticeDetail: (params) => {
        return axios.get('/api/api/article/getArticleDetails', { params })
    },
    // 获取当前用户绑定公司的最新活动
    getCompanyActivity: (params) => {
        return axios.get('/api/api/index/getCompanyActivity', { params })
    },
    // 获取所有品牌
    getBarndAll: (params) => {
        return axios.get('/api/api/index/getBarndAll', { params })
    },
    // 获取所有的栏目信息
    getColumnAll: (params) => {
        return axios.get('/api/api/index/getColumnAll', { params })
    },
    // 分页获取栏目下商品信息
    getColumnProduct: (params) => {
        return axios.get('/api/api/index/getColumnProduct', { params })
    },
    // 分页获取所有活动商品
    getActivityGoods: (params) => {
        return axios.get('/api/api/index/getAllTheProductsUnderTheEvent', { params })
    },
    // 获取pc底部文章标题
    getFooterTitle: (params) => {
        return axios.get('/api/api/navigationArticle/findAll', { params })
    },
    // 获取pc底部文章详情
    getFooterDetail: (params) => {
        return axios.get('/api/api/navigationArticle/findById', { params })
    },
    // 获取首页分组模块
    getLayoutList: (params) => {
        return axios.get('/api/api/layout/list', { params })
    },
    // 获取首页分组模块商品列表
    getSpuList: (params) => {
        return axios.get('/api/api/layout/getSpuList', { params })
    },
    // 获取首页分组模块分类列表
    getCategoryList: (params) => {
        return axios.get('/api/api/layout/getCategoryList', { params })
    },
    // 根据分组模块分类获取商品列表
    getLayoutGoodsList: (params) => {
        return axios.get('/api/api/layout/page', { params })
    },
    // 获取首页分组模块列表
    getIndexGroupList: (params) => {
        return axios.get('/api/api/index/getIndexGroupList', { params })
    },
    // 根据分组id获取商品列表
    getIndexGroupProduct: (params) => {
        return axios.get('/api/api/index/getIndexGroupProduct', { params })
    },
    //分类接口////////////////////////////////////////////////////////////////////////////////
    // 获取商品一级分类列表
    getFirstLevelCategory: (params) => {
        return axios.get('/api/api/category/getFirstLevelCategory', { params })
    },
    // 获取商品子分类列表
    getSecondLevelCategory: (params) => {
        return axios.get('/api/api/category/getSecondLevelCategory', { params })
    },
    // 获取栏目分类列表
    getCloumnClassify: (params) => {
        return axios.get('/api/api/index/getCloumnClassify', { params })
    },
    // 获取栏目一级分类
    getColumnFirstLevelCategory: (params) => {
        return axios.get('/api/api/category/getESFirstLevelCategory', { params })
    },
    // 获取栏目二级分类
    getColumnSecondLevelCategory: (params) => {
        return axios.get('/api/api/category/getESSecondLevelCategory', { params })
    },
    // 获取京东一级分类
    getJDFirstLevelCategory: (params) => {
        return axios.get('/api/api/category/getJDFirstLevelCategory', { params })
    },
    // 获取京东二级分类
    getJDSecondLevelCategory: (params) => {
        return axios.get('/api/api/category/getJDSecondLevelCategory', { params })
    },
    // 获取蛋糕一级分类
    getCakeFirstCategory: (params) => {
        return axios.get('/api/api/category/getFirstCategory', { params })
    },
    // 获取蛋糕二级分类
    getCakeSecondCategory: (params) => {
        return axios.get('/api/api/category/getSecondCategory', { params })
    },
    // 获取城市id
    getCityIdByCityName: (params) => {
        return axios.get('/api/api/cake/getCityIdByCityName', { params })
    },
    // 获取城市列表
    getCityList: (params) => {
        return axios.get('/api/api/cake/getFirstLevelCity', { params })
    },
    // 获取蛋糕品牌列表
    getBrandList: (params) => {
        return axios.get('/api/api/cake/getBrandList', { params })
    },
    // 获取当前位置信息
    getIpLngAndLat: (params) => {
        return axios.get('/api/api/cake/getIpLngAndLat', { params })
    },
    // 蛋糕专区//////////////////////////////////////////////////////////////////////////////
    // 绑定用户信息
    bindUserInfo: (params) => {
        return axios.get('/api/api/cake/bindUserInfo', { params })
    },
    // 绑定地址信息
    saveCakeAddress: (params) => {
        return axios.get('/api/api/cake/saveAddress', { params })
    },
    // 删除地址信息
    deleteCakeAddress: (params) => {
        return axios.get('/api/api/cake/deleteAddress', { params })
    },
    // 获取蛋糕配送规则
    getCakeRule: (params) => {
        return axios.get('/api/api/cake/getRule', { params })
    },
    // 验证配送规则是否一致
    getBatchRule: (params) => {
        return axios.get('/api/api/cake/getBatchRule', { params })
    },
    // 获取配送规则
    getDeliveryRule: (params) => {
        return axios.get('/api/api/cake/getDeliveryRule', { params })
    },
    // 根据商品id和城市id获取门店列表
    getCakeShopList: (params) => {
        return axios.get('/api/api/cake/getCakeShopList', { params })
    },
    // 蛋糕专区商品支付成功
    paymentSuccessful: (params) => {
        return axios.get('/api/api/order/paymentSuccessful', { params })
    },
    // 获取蛋糕门店列表
    getCakeShopPageList: (params) => {
        return axios.get('/api/api/cake/getCakeShopPageList', { params })
    },
    //商品接口////////////////////////////////////////////////////////////////////////////////
    // 获得商品列表
    getGoodsList: (params) => {
        return axios.get('/api/api/product/page', { params })
    },
    // 获得商品 SPU 列表
    getGoods: (params) => {
        return axios.get('/api/api/product/list', { params })
    },
    // 获得根据商品ID商品 SPU 列表
    getListByIds: (params) => {
        return axios.get('/api/api/product/listByIds', { params })
    },
    // 获得活动列表
    getActivityList: (params) => {
        return axios.get('/api/api/activity/getActivityList', { params })
    },
    // 获得活动详情
    getActivityDetails: (params) => {
        return axios.get('/api/api/activity/getActivityDetails', { params })
    },
    // 获得活动内分组商品列表
    getActivityProductPage: (params) => {
        return axios.get('/api/api/activity/getActivityProductPage', { params })
    },
    // 获得活动内分组详情
    getActivityGroupDetails: (params) => {
        return axios.get('/api/api/activity/getActivityGroupDetails', { params })
    },
    // 获得商品 SPU 明细
    getGoodsDetail: (params) => {
        return axios.get('/api/api/product/detail', { params })
    },
    // 查询商品购买记录列表
    productBuyRecord: (params) => {
        return axios.get('/api/api/product/productBuyRecord', { params })
    },
    // 获取京东商品库存
    getGoodsStock: (params) => {
        return axios.get('/api/api/product/getAddressStock', { params })
    },
    // 获取京东商品价格
    getJdProductPrice: (params) => {
        return axios.get('/api/api/product/querySkuPrice', { params })
    },
    // 获取京东商品信息
    getJdProductDetail: (params) => {
        return axios.get('/api/api/product/querySkuImages', { params })
    },
    // 校验云礼通商品库存
    checkYltStock: (params) => {
        return axios.post('/api/api/product/checkStock', params)
    },
    // 校验云礼通商品是否区域禁售
    checkProhibitByProductIds: (params) => {
        return axios.post('/api/api/product/checkProhibitByProductIds', params)
    },
    // 评价商品
    commentGoods: (params) => {
        return axios.post('/api/api/product/comment/save', params)
    },
    // 商品评价列表
    getCommentList: (params) => {
        return axios.get('/api/api/product/comment/queryBySpuId', { params })
    },
    //购物车接口////////////////////////////////////////////////////////////////////////////////
    // 查询用户的购物车列表
    getCarList: (params) => {
        return axios.get('/api/api/cart/list', { params })
    },
    // 查询用户在购物车中的商品数量
    getCarCount: (params) => {
        return axios.get('/api/api/cart/get-count', { params })
    },
    // 更新购物车商品数量
    updateCount: (params) => {
        return axios.post('/api/api/cart/update-count', params)
    },
    // 更新购物车商品选中
    updateSelected: (params) => {
        return axios.get('/api/api/cart/update-selected', { params })
    },
    // 添加购物车商品
    addCar: (params) => {
        return axios.post('/api/api/cart/add', params)
    },
    // 删除购物车商品
    deleteCar: (params) => {
        return axios.get('/api/api/cart/delete', { params })
    },
    //订单接口////////////////////////////////////////////////////////////////////////////////
    // 获得订单结算信息
    settlement: (params) => {
        return axios.post('/api/api/order/settlement', params)
    },
    // 创建订单
    createOrder: (params) => {
        return axios.post('/api/api/order/create', params)
    },
    // 支付
    goToPay: (params) => {
        return axios.get('/api/api/order/goToPay', { params })
    },
    // 根据订单状态查询订单列表
    getOrderPage: (params) => {
        return axios.get('/api/api/order/getOrderPage', { params })
    },
    // 获取售后子订单
    getSaleOrderPage: (params) => {
        return axios.get('/api/api/order/findAfterSalesOrderPage', { params })
    },
    // 获取订单详情
    getOrderInfo: (params) => {
        return axios.get('/api/api/order/getOrderInfo', { params })
    },
    // 取消订单
    cancelOrder: (params) => {
        return axios.get('/api/api/order/cancelOrder', { params })
    },
    // 确认收货
    confirmReceipt: (params) => {
        return axios.get('/api/api/order/confirmReceipt', { params })
    },
    // 查询订单物流信息
    queryOrderLogistics: (params) => {
        return axios.get('/api/api/order/queryOrderLogistics', { params })
    },
    // 查询京东订单物流信息
    queryOrderLogisticsData: (params) => {
        return axios.get('/api/api/order/queryOrderLogisticsData', { params })
    },
    // 申请售后
    applyAfterSale: (params) => {
        return axios.get('/api/api/order/applyAfterSale', { params })
    },
    // 获取售后订单详情
    getSubOrderInfo: (params) => {
        return axios.get('/api/api/order/getSubOrderInfo', { params })
    },
    // 提交退货物流单号
    confirmRefund: (params) => {
        return axios.get('/api/api/order/submitReturnLogisticsTrackingNumber', { params })
    },
    // 取消售后
    cancelAfterSale: (params) => {
        return axios.get('/api/api/order/cancelApplicationForAfterSalesService', { params })
    },
    // 京东订单申请售后
    applyAfterSaleJD: (params) => {
        return axios.post('/api/api/order/applyForAfterSalesService', params)
    },
    // 京东订单详情
    queryJDOrderDetail: (params) => {
        return axios.get('/api/api/order/queryJDOrderDetail', { params })
    },
    // 判断是否能创建京东订单
    checkProduct: (params) => {
        return axios.get('/api/api/product/checkProduct', { params })
    },
    // 获取京东商品轮播图
    getProductImage: (params) => {
        return axios.get('/api/api/product/getProductImage', { params })
    },
    // 获取京东商品预计配送时间
    getProductDeliveryTime: (params) => {
        return axios.get('/api/api/product/getProductDeliveryTime', { params })
    },
    // 获取京东商品赠品信息
    getProductGift: (params) => {
        return axios.get('/api/api/product/getProductGift', { params })
    },
    //我的接口//////////////////////////////////////////////////////////////////////////////////////////
    // 获取用户信息
    getInfo: (params) => {
        return axios.get('/api/api/my/getInfo', { params })
    },
    // 修改用户信息
    changeInfo: (params) => {
        return axios.post('/api/api/login/modifyingUserInfo', params)
    },
    // 查询通知消息列表
    getMsgList: (params) => {
        return axios.get('/api/api/my/list', { params })
    },
    // 查询通知消息详情
    getMsgInfo: (params) => {
        return axios.get('/api/api/my/getMsgInfo', { params })
    },
    // 新增用户反馈
    feedback: (params) => {
        return axios.post('/api/api/my', params)
    },
    // 获取授信信息
    getUserAuth: (params) => {
        return axios.get('/api/api/my/queryUserAuthorization', { params })
    },
    // 申请资质
    applyUserAuth: (params) => {
        return axios.post('/api/api/my/applicationAuthorization', params)
    },
    // 查询用户授信使用记录列表
    queryUseLimitRecord: (params) => {
        return axios.get('/api/api/my/queryUseLimitRecord', { params })
    },
    // 关于我们
    getAboutInfo: (params) => {
        return axios.get('/api/api/my/getAboutInfo', { params })
    },
    // 获取积分明细
    getIntegralRecord: (params) => {
        return axios.get('/api/api/my/queryUserIntegralRecord', { params })
    },
    // 获取猜你喜欢商品列表
    getGuessYouLike: (params) => {
        return axios.get('/api/api/product/getRecommendations', { params })
    },
    // 获取收藏列表
    getCollectList: (params) => {
        return axios.get('/api/api/userFavorite/listByUser', { params })
    },
    // 添加收藏
    addCollect: (params) => {
        return axios.post('/api/api/userFavorite/add', params)
    },
    // 取消收藏
    cancelCollect: (params) => {
        return axios.post('/api/api/userFavorite/cancel', params)
    },
    // 批量取消收藏
    cancelCollectBatch: (params) => {
        return axios.post('/api/api/userFavorite/batchCancel', params)
    },
    // 获取浏览记录列表
    getBrowseRecord: (params) => {
        return axios.get('/api/api/userBrowseHistory/listByUser', { params })
    },
    // 清空浏览记录
    clearBrowseRecord: (params) => {
        return axios.post('/api/api/userBrowseHistory/clear', params)
    },
    // 我的评价
    getMyComment: (params) => {
        return axios.get('/api/api/product/comment/queryByUserId', { params })
    },
    //收货地址///////////////////////////////////////////////////////////////////////////////////////////
    // 获取所有的收货地址
    getAddressList: (params) => {
        return axios.get('/api/api/address/getUserAddressList', { params })
    },
    // 获取用户默认收货地址
    getDefaultAddress: (params) => {
        return axios.get('/api/api/address/getDefaultAddress', { params })
    },
    // 查询用户收货地址详情
    getAddressInfo: (params) => {
        return axios.get('/api/api/address/getAddressInfo', { params })
    },
    // 删除用户收货地址
    deleteAddress: (params) => {
        return axios.get('/api/api/address/deleteAddress', { params })
    },
    // 修改用户收获地址
    updateAddress: (params) => {
        return axios.post('/api/api/address/updateAddress', params)
    },
    // 设置默认收货地址
    setAddressDefault: (params) => {
        return axios.post('/api/api/address/setUserAddressToDefault', params)
    },
    // 保存用户收货地址
    saveAddress: (params) => {
        return axios.post('/api/api/address/addUserAddress', params)
    },
    // 获取地区ID
    getCountryId: (params) => {
        return axios.get('/api/JDReceive/JDAddressTranscoding', { params })
    },
    // 获取街道
    getStreet: (params) => {
        return axios.get('/api/JDReceive/queryJdAreaIdList', { params })
    },
    // 发票接口////////////////////////////////////////////////////////////////////////////////////////////////
    // 获取我的发票列表
    getInvoiceList: (params) => {
        return axios.get('/api/api/invoice/getInvoiceList', { params })
    },
    // 新增发票
    addInvoice: (params) => {
        return axios.post('/api/api/invoice/addInvoice', params)
    },
    // 获取发票详情
    getInvoiceInfo: (params) => {
        return axios.get('/api/api/invoice/getInvoiceInfo', { params })
    },
    // 修改发票
    updateInvoice: (params) => {
        return axios.post('/api/api/invoice/updateInvoice', params)
    },
    // 删除发票
    deleteInvoice: (params) => {
        return axios.get('/api/api/invoice/deleteInvoice', { params })
    },
    //卡片接口////////////////////////////////////////////////////////////////////////////////////////////////
    // 兑换福利卡
    exchange: (params) => {
        return axios.get('/api/api/welfareCard/recharge', { params })
    },
    // 充值福利卡
    recharge: (params) => {
        return axios.get('/api/api/welfareCard/createRechargeOrder', { params })
    },
    // 查询福利卡流水列表
    getwelfList: (params) => {
        return axios.get('/api/api/welfareCard/list', { params })
    },
    // 获取卡包列表
    getCardList: (params) => {
        return axios.get('/api/api/userCoupons/list', { params })
    },
    // 获取兑换电子卡验证码
    exchangeSms: (params) => {
        return axios.get('/api/api/userCoupons/exchangeSms', { params })
    },
    // 兑换电子卡
    rechargeDigital: (params) => {
        return axios.get('/api/api/userCoupons/rechargeDigital', { params })
    },
    // 电子卡转赠
    donateDigital: (params) => {
        return axios.get('/api/api/userCoupons/donateDigital', { params })
    },
    // 余额转赠
    donateBalance: (params) => {
        return axios.get('/api/api/my/donateBalance', { params })
    },
    // 卡转赠记录
    donateList: (params) => {
        return axios.get('/api/api/userCoupons/donateList', { params })
    },
    //活动专区接口////////////////////////////////////////////////////////////////////////////////////////////////
    // 获取优惠活动信息
    getSpecial: (params) => {
        return axios.get('/api/api/special/getSpecial', { params })
    },
    // 获取优惠活动列表
    getSpecialGoodsList: (params) => {
        return axios.get('/api/api/special/list', { params })
    },
    // 获取预约活动信息
    getYu: (params) => {
        return axios.get('/api/api/special/getYu', { params })
    },
    // 获取秒杀活动信息
    getSeckill: (params) => {
        return axios.get('/api/api/index/getSecondsKill', { params })
    },
    // 获取秒杀活动场次列表
    getTimeList: (params) => {
        return axios.get('/api/api/secondsKill/getRound', { params })
    },
    // 获取秒杀活动商品列表
    getSeckillGoodsList: (params) => {
        return axios.get('/api/api/secondsKill/getProductByRound', { params })
    },
    //电影专区接口////////////////////////////////////////////////////////////////////////////////////////////////
    // 根据城市名字获取电影城市信息
    getMovieByCityName: (params) => {
        return axios.get('/api/api/movie/getCityByCityName', { params })
    },
    // 获取城市列表
    getAllCitys: (params) => {
        return axios.get('/api/api/movie/getAllCitys', { params })
    },
    // 获取电影影片类型
    getMovieTypes: (params) => {
        return axios.get('/api/api/movie/getTypes', { params })
    },
    // 获取电影宣传片列表
    getVideoList: (params) => {
        return axios.get('/api/api/movie/getFilmPromotion', { params })
    },
    // 获取电影首页数据
    getMovieHome: (params) => {
        return axios.get('/api/api/movie/getFilms', { params })
    },
    // 获取影片列表
    getMovieList: (params) => {
        return axios.get('/api/api/movie/list', { params })
    },
    // 获取影院列表
    getCinemaList: (params) => {
        return axios.get('/api/api/movie/getCinemas', { params })
    },
    // 获取影院区域列表
    getAreaList: (params) => {
        return axios.get('/api/api/movie/getRegions', { params })
    },
    // 获取影片详情
    getMovieDetail: (params) => {
        return axios.get('/api/api/movie/getFilmDetail', { params })
    },
    // 获取影院详情
    getCinemaDetail: (params) => {
        return axios.get('/api/api/movie/getCinemaDetail', { params })
    },
    // 获取日期列表
    getScheduleDates: (params) => {
        return axios.get('/api/api/movie/getScheduleDates', { params })
    },
    // 获取电影时间排期
    getSchedules: (params) => {
        return axios.get('/api/api/movie/getNewSchedules', { params })
    },
    // 获取座位图列表
    getSeatMap: (params) => {
        return axios.get('/api/api/movie/getSeatMap', { params })
    },
    // 确认选座
    createOrderMovie: (params) => {
        return axios.post('/api/api/movie/createOrder', params)
    },
    // 订单支付
    payOrderMovie: (params) => {
        return axios.post('/api/api/movie/payOrder', params)
    },
    // 取消订单
    cancelOrderMovie: (params) => {
        return axios.post('/api/api/movie/cancelOrder', params)
    },
    // 获取电影订单列表
    getMovieOrderList: (params) => {
        return axios.get('/api/api/movie/orderList', { params })
    },
    // 根据订单id获取订单详情
    getMovieOrderDetail: (params) => {
        return axios.get('/api/api/movie/getOrderDetail', { params })
    },
    // 申请售后
    applyRefundMovie: (params) => {
        return axios.post('/api/api/movie/refundOrder', params)
    },
    //虚拟卡券专区////////////////////////////////////////////////////////////////////////////////////////////
    // 卡券分类列表
    getCouponCategoryList: (params) => {
        return axios.get('/api/api/fulu/getIndexCategorys', { params })
    },
    // 卡券二级分类
    findSonList: (params) => {
        return axios.get('/api/api/fulu/findSonList', { params })
    },
    // 卡券列表
    getCouponList: (params) => {
        return axios.get('/api/api/fulu/showCategory', { params })
    },
    // 卡券详情
    getCouponDetail: (params) => {
        return axios.get('/api/api/fulu/showDetail', { params })
    },
    // 到货提醒
    remindArrival: (params) => {
        return axios.post('/api/api/product/restockApply', params)
    },
    // 加入购物车
    couponAddCart: (params) => {
        return axios.post('/api/api/cart/addFulu', params)
    },
    // 结算中心信息
    couponSettlement: (params) => {
        return axios.post('/api/api/fulu/order/settlementOrder', params)
    },
    // 创建卡券订单
    createCouponOrder: (params) => {
        return axios.post('/api/api/fulu/order/createOrder', params)
    },
    // 获取支付信息
    getCouponOrderInfo: (params) => {
        return axios.get('/api/api/fulu/order/payDetail', { params })
    },
    // 立即支付
    payCouponOrder: (params) => {
        return axios.post('/api/api/fulu/order/payNow', params)
    },
    // 获取订单列表
    getCouponOrderList: (params) => {
        return axios.get('/api/api/fulu/order/list', { params })
    },
    // 获取订单详情
    getCouponOrderDetail: (params) => {
        return axios.get('/api/api/fulu/order/detail', { params })
    },
    // 取消订单
    cancelCouponOrder: (params) => {
        return axios.get('/api/api/fulu/order/cancelOrder', { params })
    },
    //售后接口////////////////////////////////////////////////////////////////////////////////////////////////
    // 根据子订单id获取可售后商品
    getGoodsAttributes: (params) => {
        return axios.get('/api/api/order/afterSales/getGoodsAttributes', { params })
    },
    // 申请售后(修改)
    applyRefund: (params) => {
        return axios.post('/api/api/order/afterSales/applyAfterSale', params)
    },
    // 根据子订单id获取用户地址信息
    getOrderAddressInfo: (params) => {
        return axios.get('/api/api/order/afterSales/getSubOrderInfo', { params })
    },
    // 获取售后订单列表
    getRefundOrderList: (params) => {
        return axios.get('/api/api/order/afterSales/list', { params })
    },
    // 获取售后订单详情
    getRefundOrderDetail: (id) => {
        return axios.get('/api/api/order/afterSales/' + id, {})
    },
    // 取消售后
    cancelRefund: (params) => {
        return axios.post('/api/api/order/afterSales/cancelAfterSale', params)
    },
    // 售后-客户确认
    confirmAfterSale: (params) => {
        return axios.post('/api/api/order/afterSales/confirmAfterSale', params)
    },
    // 获取快递公司列表
    getExpressList: (params) => {
        return axios.get('/api/api/order/afterSales/getExpressList', { params })
    },
    // 售后发货
    refundDelivery: (params) => {
        return axios.post('/api/api/order/afterSales/delivery', params)
    },
    //拼团专区////////////////////////////////////////////////////////////////////////////////////////////////
    // 获取拼团活动列表
    getGroupActivityList: (params) => {
        return axios.get('/api/api/groupon/list', { params })
    },
    // 获取拼团商品列表
    getGroupGoodsList: (params) => {
        return axios.get('/api/api/groupon/products', { params })

    },
    // 获取拼团商品详情
    getGroupGoodDetail: (params) => {
        return axios.get('/api/api/groupon/detail', { params })
    },
    // 获取拼团结算中心数据
    getGroupSettlement: (params) => {
        return axios.post('/api/api/groupon/settlement', params)
    },
    // 创建
    createGroupOrder: (params) => {
        return axios.post('/api/api/groupon/order', params)
    },
    // 专区数据
    userActivityIntegralList: (params) => {
        return axios.get('/api/api/welfareCard/userActivityIntegralList', { params })
    },
}

export default mall;